// extracted by mini-css-extract-plugin
export var standaloneTable = "_gm-0";
export var standaloneTableWithBodyFill = "_gm-1";
export var withExtraHeader = "_gm-2";